export type BrandKey = 'enstilar' | 'dovobet' | 'generic' | 'other'

export type Brand = {
  key: BrandKey
  name: string
  form: string
  color: string
}

export const brands: Brand[] = [
  {
    key: 'enstilar',
    name: 'ENSTILAR®',
    form: 'Cal/BD Foam',
    color: '#1F3C88',
  },
  {
    key: 'dovobet',
    name: 'DOVOBET®',
    form: 'Ointment / Gel',
    color: '#6B4EA8',
  },
  { key: 'generic', name: 'GENERIC', form: 'Cal/BD', color: '#4C9A2A' },
  { key: 'other', name: 'OTHER', form: 'Topical steroid', color: '#8A8F98' },
]

export const brandByKey: Record<BrandKey, Brand> = brands.reduce(
  (acc, brand) => ({ ...acc, [brand.key]: brand }),
  {} as Record<BrandKey, Brand>,
)

export type Criterion = {
  id: string
  rank: number
  label: string
  /** Share of prescribing decisions HCPs say this criterion drives. */
  importance: number
  note: string
  /** How HCPs rate each option today, 1 (weaker) to 5 (stronger). */
  hcp: Record<BrandKey, number>
  /** What LEO holds to be true about each option, same scale. */
  leo: Record<BrandKey, number>
}

export const criteria: Criterion[] = [
  {
    id: 'efficacy',
    rank: 1,
    label: 'Efficacy',
    importance: 92,
    note: 'Clearance at week 4',
    hcp: { enstilar: 3.6, dovobet: 4.2, generic: 3.0, other: 3.3 },
    leo: { enstilar: 4.6, dovobet: 4.0, generic: 3.1, other: 3.4 },
  },
  {
    id: 'speed',
    rank: 2,
    label: 'Speed of action',
    importance: 78,
    note: 'Visible relief inside 7 days',
    hcp: { enstilar: 3.9, dovobet: 3.4, generic: 2.6, other: 4.1 },
    leo: { enstilar: 4.8, dovobet: 3.3, generic: 2.7, other: 4.2 },
  },
  {
    id: 'experience',
    rank: 3,
    label: 'Patient experience',
    importance: 64,
    note: 'Vehicle, mess, daily burden',
    hcp: { enstilar: 3.4, dovobet: 3.1, generic: 2.4, other: 3.6 },
    leo: { enstilar: 4.4, dovobet: 2.9, generic: 2.2, other: 3.5 },
  },
  {
    id: 'safety',
    rank: 4,
    label: 'Safety',
    importance: 51,
    note: 'Steroid load, sensitive sites',
    hcp: { enstilar: 3.5, dovobet: 3.8, generic: 3.4, other: 2.6 },
    leo: { enstilar: 3.8, dovobet: 3.7, generic: 3.4, other: 2.4 },
  },
  {
    id: 'control',
    rank: 5,
    label: 'Long-term control',
    importance: 37,
    note: 'Time to relapse, proactive use',
    hcp: { enstilar: 3.0, dovobet: 3.6, generic: 2.9, other: 2.2 },
    leo: { enstilar: 3.9, dovobet: 3.4, generic: 2.8, other: 2.0 },
  },
]

export type GapRow = {
  label: string
  perceived: number
  believed: number
  importance: number
  verdict: string
}

export const gapRows: GapRow[] = criteria.map((criterion) => ({
  label: criterion.label,
  perceived: criterion.hcp.enstilar,
  believed: criterion.leo.enstilar,
  importance: criterion.importance,
  verdict: verdictFor(criterion.leo.enstilar - criterion.hcp.enstilar),
}))

function verdictFor(delta: number): string {
  if (delta >= 0.9) return 'Belief gap'
  if (delta >= 0.5) return 'Soft gap'
  return 'Aligned'
}


